//@flow

import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import {BulletPoint} from "@/components";
import type { BulletPointProps } from "@/components/BulletPoint/BulletPoint";
import {chunks} from "@/utils";

type Props = {
    bulletPoints: ({ id: string } & BulletPointProps)[],
};

const BulletPoints = ({bulletPoints}: Props): React$Element<React$FragmentType> => {
    const rows = chunks(bulletPoints, 3).map((chunk, index) => {
        const columns = chunk.map(bulletPoint => (
            <Col md={4} key={bulletPoint.id} className={"my-4"}>
                <BulletPoint
                    title={bulletPoint.title}
                    content={bulletPoint.content}
                    link={bulletPoint.link}
                />
            </Col>
        ));

        return <Row key={index}>{columns}</Row>;
    });
    return <>{rows}</>;
};

export default BulletPoints;
